package com.bulut.mecitogullari.ui.auth

import androidx.compose.runtime.Composable

sealed interface GoogleSignInResult {
    /** Google handed us tokens (at least one); exchange them for a Firebase session. */
    data class Token(val idToken: String?, val accessToken: String?) : GoogleSignInResult

    /** The platform flow signed into Firebase directly (web popup). */
    data object SignedInDirectly : GoogleSignInResult

    data class Failed(val message: String?) : GoogleSignInResult

    data object Cancelled : GoogleSignInResult
}

/**
 * Platform Google Sign-In flow around a custom button.
 * Android/iOS use KMPAuth (Credential Manager / GoogleSignIn SDK);
 * web opens the Firebase JS popup.
 */
@Composable
expect fun GoogleSignInContainer(
    onResult: (GoogleSignInResult) -> Unit,
    content: @Composable (onClick: () -> Unit) -> Unit,
)
